export const SITE_URL = "https://towerlinkgcc.com";
export const DEFAULT_SOCIAL_IMAGE = "https://images.unsplash.com/photo-1643155193188-38eb08e2b54f?auto=format&fit=crop&w=1200&h=630&q=85";

const SEO_BY_SLUG = {
  home: {
    en: {
      title: "Telecom Towers, Materials & RFQ Platform Saudi Arabia | TowerLink",
      description: "TowerLink connects project owners with qualified suppliers, contractors and engineering companies across Saudi Arabia and the GCC for telecom towers, infrastructure, materials and specialized sourcing.",
    },
    ar: {
      title: "أبراج الاتصالات والمواد وطلبات الأسعار في السعودية | TowerLink",
      description: "تربط TowerLink أصحاب المشاريع بالموردين والمقاولين وشركات الهندسة المؤهلة في السعودية والخليج لتلبية احتياجات أبراج الاتصالات والبنية التحتية والمواد والتوريد المتخصص.",
    },
  },
  "tower-solutions": {
    en: {
      title: "Telecom Towers Saudi Arabia | Monopole & Self-Support | TowerLink",
      description: "Source telecom tower solutions in Saudi Arabia including monopoles, self-support, 3-leg, 4-leg, guyed and rooftop towers with design, supply and installation support.",
    },
    ar: {
      title: "أبراج الاتصالات في السعودية | مونوبول وذاتية الدعم | TowerLink",
      description: "حلول أبراج الاتصالات في السعودية تشمل المونوبول والأبراج ذاتية الدعم والثلاثية والرباعية والمشدودة وأبراج الأسطح مع التصميم والتوريد والتركيب.",
    },
  },
  "telecom-materials": {
    en: {
      title: "Telecom Materials & Network Equipment Saudi Arabia | TowerLink",
      description: "Request telecom materials and network equipment in Saudi Arabia including antennas, RF accessories, fiber, cabinets, power systems, batteries, earthing and tower accessories.",
    },
    ar: {
      title: "مواد ومعدات الاتصالات والشبكات في السعودية | TowerLink",
      description: "اطلب مواد ومعدات الاتصالات في السعودية بما يشمل الهوائيات وملحقات RF والألياف والكبائن وأنظمة الطاقة والبطاريات والتأريض وملحقات الأبراج.",
    },
  },
  "import-from-europe": {
    en: {
      title: "Import Vitamins & Supplements from Europe to Saudi Arabia | TowerLink",
      description: "Source vitamins, minerals, multivitamins, Omega-3, collagen, probiotics and private-label supplements from European manufacturers for Saudi Arabia and the GCC.",
    },
    ar: {
      title: "استيراد الفيتامينات والمكملات من أوروبا إلى السعودية | TowerLink",
      description: "توريد واستيراد الفيتامينات والمعادن والمالتي فيتامين وأوميغا 3 والكولاجين والبروبيوتيك ومنتجات Private Label من مصنعين أوروبيين للسعودية والخليج.",
    },
  },
  projects: {
    en: {
      title: "Telecom & Infrastructure Project Solutions Saudi Arabia | TowerLink",
      description: "Explore TowerLink telecom and infrastructure project solutions for towers, network materials, civil works, fiber, power and specialized procurement across Saudi Arabia and the GCC.",
    },
    ar: {
      title: "حلول مشاريع الاتصالات والبنية التحتية في السعودية | TowerLink",
      description: "تعرف على حلول TowerLink لمشاريع الأبراج ومواد الشبكات والأعمال المدنية والألياف والطاقة والمشتريات المتخصصة في السعودية والخليج.",
    },
  },
  industries: {
    en: {
      title: "Telecom Infrastructure for Saudi Industries & Mega Projects | TowerLink",
      description: "Telecom infrastructure and procurement solutions for operators, oil and gas, utilities, government, smart cities, contractors and mega projects in Saudi Arabia and the GCC.",
    },
    ar: {
      title: "البنية التحتية للاتصالات للقطاعات والمشاريع الكبرى | TowerLink",
      description: "حلول بنية تحتية ومشتريات للاتصالات للمشغلين والنفط والغاز والمرافق والجهات الحكومية والمدن الذكية والمقاولين والمشاريع الكبرى في السعودية والخليج.",
    },
  },
  "request-quotation": {
    en: {
      title: "Request Telecom & Infrastructure Quotation Saudi Arabia | TowerLink",
      description: "Submit your telecom tower, infrastructure, material or equipment requirements and request quotations from relevant suppliers and contractors through TowerLink.",
    },
    ar: {
      title: "اطلب عرض سعر لمشروع اتصالات أو بنية تحتية | TowerLink",
      description: "أرسل متطلبات الأبراج أو البنية التحتية أو المواد والمعدات واطلب عروض أسعار من الموردين والمقاولين المناسبين عبر TowerLink.",
    },
  },
  "how-it-works": {
    en: {
      title: "How TowerLink RFQ Platform Works | Saudi Arabia & GCC",
      description: "Learn how TowerLink receives project requirements, matches them with relevant suppliers and contractors, and helps companies compare suitable telecom and infrastructure offers.",
    },
    ar: {
      title: "كيف تعمل منصة TowerLink لطلبات الأسعار في السعودية والخليج",
      description: "تعرف على كيفية استقبال TowerLink لمتطلبات المشروع وربطها بالموردين والمقاولين المناسبين ومساعدة الشركات على مقارنة عروض الاتصالات والبنية التحتية.",
    },
  },
  partners: {
    en: {
      title: "Join Telecom Supplier & Contractor Network Saudi Arabia | TowerLink",
      description: "Register your company with TowerLink to join a network of telecom suppliers, tower contractors, infrastructure companies and specialized service providers in Saudi Arabia and the GCC.",
    },
    ar: {
      title: "انضم لشبكة موردي ومقاولي الاتصالات في السعودية | TowerLink",
      description: "سجل شركتك في TowerLink للانضمام إلى شبكة موردي الاتصالات ومقاولي الأبراج وشركات البنية التحتية ومقدمي الخدمات المتخصصة في السعودية والخليج.",
    },
  },
  about: {
    en: {
      title: "About TowerLink | Telecom Procurement & Partner Platform",
      description: "Learn about TowerLink, a B2B platform connecting telecom and infrastructure project requirements with qualified suppliers, contractors and sourcing partners in Saudi Arabia and the GCC.",
    },
    ar: {
      title: "عن TowerLink | منصة مشتريات وشركاء قطاع الاتصالات",
      description: "تعرف على TowerLink، منصة B2B تربط متطلبات مشاريع الاتصالات والبنية التحتية بالموردين والمقاولين وشركاء التوريد في السعودية والخليج.",
    },
  },
  contact: {
    en: {
      title: "Contact TowerLink | Telecom RFQ & Sourcing Saudi Arabia",
      description: "Contact TowerLink for telecom tower requirements, infrastructure RFQs, telecom materials, European sourcing and supplier partnership enquiries in Saudi Arabia and the GCC.",
    },
    ar: {
      title: "تواصل مع TowerLink | طلبات الاتصالات والتوريد في السعودية",
      description: "تواصل مع TowerLink لطلبات أبراج الاتصالات والبنية التحتية ومواد الاتصالات والاستيراد من أوروبا واستفسارات الشراكة مع الموردين في السعودية والخليج.",
    },
  },
  privacy: {
    en: { title: "Privacy Policy | TowerLink", description: "TowerLink privacy policy and information about how website and enquiry data is handled." },
    ar: { title: "سياسة الخصوصية | TowerLink", description: "سياسة الخصوصية في TowerLink ومعلومات حول التعامل مع بيانات الموقع والطلبات." },
  },
  terms: {
    en: { title: "Terms & Conditions | TowerLink", description: "Terms and conditions governing the use of the TowerLink platform and website." },
    ar: { title: "الشروط والأحكام | TowerLink", description: "الشروط والأحكام المنظمة لاستخدام منصة وموقع TowerLink." },
  },
  disclaimer: {
    en: { title: "Disclaimer | TowerLink", description: "Important disclaimer regarding TowerLink platform information, sourcing and project enquiries." },
    ar: { title: "إخلاء المسؤولية | TowerLink", description: "إخلاء المسؤولية المتعلق بمعلومات منصة TowerLink وطلبات التوريد والمشاريع." },
  },
};

export const getBuiltinSeo = (slug, lang = "en") => SEO_BY_SLUG?.[slug]?.[lang] || SEO_BY_SLUG?.[slug]?.en || null;

const ensureMeta = (key, value, attr = "name") => {
  let el = document.querySelector(`meta[${attr}='${key}']`);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const ensureCanonical = (href) => {
  let link = document.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const ensureStructuredData = ({ title, description, canonical, lang }) => {
  let script = document.getElementById("towerlink-seo-jsonld");
  if (!script) {
    script = document.createElement("script");
    script.id = "towerlink-seo-jsonld";
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: canonical,
    inLanguage: lang === "ar" ? "ar-SA" : "en",
    isPartOf: {
      "@type": "WebSite",
      name: "TowerLink Platform",
      url: `${SITE_URL}/`,
    },
  });
};

export const applySeo = ({ title, description, pathname = "/", lang = "en", image = "", robots = "index,follow" }) => {
  if (title) document.title = title;
  document.documentElement.lang = lang === "ar" ? "ar" : "en";

  const cleanPath = pathname === "/" ? "/" : `/${String(pathname).replace(/^\/+|\/+$/g, "")}`;
  const canonical = `${SITE_URL}${cleanPath}`;
  const locale = lang === "ar" ? "ar_SA" : "en_US";
  const socialImage = image || DEFAULT_SOCIAL_IMAGE;

  ensureMeta("description", description);
  ensureMeta("robots", robots);
  ensureMeta("googlebot", robots);

  ensureMeta("og:title", title, "property");
  ensureMeta("og:description", description, "property");
  ensureMeta("og:type", "website", "property");
  ensureMeta("og:url", canonical, "property");
  ensureMeta("og:site_name", "TowerLink Platform", "property");
  ensureMeta("og:locale", locale, "property");
  ensureMeta("og:image", socialImage, "property");
  ensureMeta("og:image:secure_url", socialImage, "property");
  ensureMeta("og:image:type", "image/jpeg", "property");
  ensureMeta("og:image:width", "1200", "property");
  ensureMeta("og:image:height", "630", "property");
  ensureMeta("og:image:alt", "TowerLink telecom infrastructure platform", "property");

  ensureMeta("twitter:card", "summary_large_image");
  ensureMeta("twitter:title", title);
  ensureMeta("twitter:description", description);
  ensureMeta("twitter:image", socialImage);

  ensureCanonical(canonical);
  ensureStructuredData({ title, description, canonical, lang });
};